import React from 'react';
import styled from 'styled-components';
import CustomLabel from '../label/CustomLabel';
import NormalBtn from '../button/NormalBtn';
import IconBtn from '../button/IconBtn';
import CustomTitle from '../title/CustomTitle';

/**
 * Modal 팝업 안에 들어가는 일반 팝업 
 */
const NormalPopupBlock = styled.div` 
width: 100%;
height: 100%;
border-radius: 10px;
`;

const NormalPopupContentsBlock = styled.div`
    width: 97%;
    height: auto;
    background-color:#fff;
    border-radius: 10px;
    padding: 30px;
`;

const NormalPopupTitleContainerBlock = styled.div`
    //margin: 0 auto;
    text-align: center;
    //height: '50%';
    //width: '90%';
`;


const NormalPopupBtnBlock = styled.div`
    width: 110px;
    height: 40px;
    display: block;
    margin-top: ${props => props.marginTop || '10px'};
    margin-right: ${props => props.marginRight || '0px'};
    margin-left: ${props => props.marginLeft || '0px'};
`

export const NomalPopupOneBtnStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '10%',
        transform: 'translate(-50%, -50%)',
        zIndex: '999',
        overlay: 'auto',
        WebkitOverflowScrolling: 'touch',
        width: "350px",
        height: "auto",
        borderRadius: '0px',
        backgroundColor: 'transparent',
        borderWidth: '0px',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '1000'
    },
};

const NormalPopupOneBtn = ({ text, text2, text3, btn,
    onClick }) => {
    return (
        <NormalPopupBlock>
            <NormalPopupContentsBlock>

                <NormalPopupTitleContainerBlock >

                    <CustomTitle
                        title={text} textColor="#111"
                        fontSize="16px" fontWeight='500'
                        marginTop="10px" textAlign="center"
                        marginBottom="10px" 
                        height = "auto"
                        lineHeight = "24px"
                        display = {(text !== null && text !== undefined && text.length > 0) ? "block":"none"}/>
                    <CustomTitle
                        title={text2} textColor="#111"
                        fontSize="16px" fontWeight='500'
                        marginTop="10px" textAlign="center"
                        marginBottom="10px" 
                        height = "auto"
                        lineHeight = "24px"
                        display = {(text2 !== null && text2 !== undefined && text2.length > 0) ? "block":"none"}/>
                    <CustomTitle
                        title={text3} textColor="#111"
                        fontSize="16px" fontWeight='300'
                        marginTop="10px" textAlign="center"
                        marginBottom="10px" 
                        height = "auto"
                        lineHeight = "24px"
                        display = {(text3 !== null && text3 !== undefined && text3.length > 0) ? "block":"none"}/>

                    <NormalPopupBtnBlock marginRight='auto' marginLeft='auto'marginTop='30px' >
                        <NormalBtn text={btn}
                            width="110px" height="40px"
                            fontSize="14x" display="inline-block"
                            borderRadius="20px" textColor="#fff"
                            onClick={onClick} bgColor="#111" fontWeight="400"
                            marginTop='0px'
                        />
                    </NormalPopupBtnBlock>

                </NormalPopupTitleContainerBlock>

            </NormalPopupContentsBlock>

        </NormalPopupBlock>
    );
};

export default NormalPopupOneBtn;